import React, { useEffect } from 'react';
import bgImage from '../../assets/img/AdobeStock_461884798.jpeg';
import { Helmet } from 'react-helmet';
import Header from '../../comp/Header';

function Sistemas(props) {
  useEffect(() => {
    props.setBackgroundImage(bgImage);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Enginios - Sistemas IT</title>
        <meta name="description" content= "Monta tu propia red informática con Enginios para no depender de las grandes tecnológicas. Sistemas en nube, alojamiento web, acceso remoto y mucho más."/>
        <meta name="keywords" content="Enginios redes, Enginios sistemas, Enginios seguridad, Enginios nube"/>
        <meta name="robots" content= "index, follow"/>
      </Helmet>
      <Header title="Sistemas IT" />
      <div className="mainBlank">
        <main>
          <h2>Toda la infraestructura informática y red de comunicaciones que necesitas para tu empresa</h2>
          <p>Enginios, en su afán de autogestionar su infraestructura de red informática sin tener que depender de costosas cuotas mensuales a las grandes tecnológicas, ha aprendido a gestionar de forma propia, flexible y económica unas herramientas que nos han sido de gran utilidad para el despliegue de nuestros servicios.</p>
          <h3>Ahora, ponemos toda esa experiencia a tu disposición</h3>
          <p>Ya sea en servidores propios de Enginios o en un servidor que podemos montar en tu ubicación física, disfruta de:</p>
          <ol>
              <li>Alojamiento para tu página web</li>
              <li>Servicio de nube</li>
              <li>Acceso remoto a tus carpetas en red</li>
          </ol>
        </main>
      </div>
    </div>
    
  );
};

export default Sistemas